import React from "react";

const AuthenticationHOC= Component => props => {
  if(props.rehydrated){
    return <Component {...props}/>;
  }
  else{
    return "Loading"
  }
}

export default AuthenticationHOC
